(() => {
  const storefrontRoots = ['/collections', '/products', '/pages', '/policies', '/search', '/cart', '/blogs', '/account'];
  const knownLocalePrefixes = ['/en-sa', '/ar-sa', '/en', '/ar'];

  const currentPrefix = () => {
    const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    return language === 'ar' ? '/ar-sa' : '/en-sa';
  };

  const stripKnownPrefix = (pathname) => {
    for (const prefix of knownLocalePrefixes) {
      if (pathname === prefix) return '/';
      if (pathname.startsWith(`${prefix}/`)) return pathname.slice(prefix.length);
    }
    return pathname;
  };

  const localizeHref = (href) => {
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:') || href.startsWith('//')) return href;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch {
      return href;
    }

    if (url.origin !== window.location.origin) return href;

    const prefix = currentPrefix();
    const pathname = stripKnownPrefix(url.pathname);
    const isStorefrontPath = pathname === '/' || storefrontRoots.some((root) => pathname === root || pathname.startsWith(`${root}/`));

    if (!isStorefrontPath) return href;

    const localizedPath = pathname === '/' ? `${prefix}/` : `${prefix}${pathname}`;
    return `${localizedPath}${url.search}${url.hash}`;
  };

  const updateAnchor = (anchor) => {
    const href = anchor.getAttribute('href');
    const localizedHref = localizeHref(href);
    if (localizedHref && localizedHref !== href) anchor.setAttribute('href', localizedHref);
  };

  const updateLinks = (root) => {
    if (root.nodeType === 1 && root.matches && root.matches('a[href]')) updateAnchor(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(updateAnchor);
  };

  const start = () => {
    updateLinks(document);

    document.addEventListener('click', (event) => {
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (anchor) updateAnchor(anchor);
    }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(updateLinks);
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();